import { ActionTypes as action } from "./action-types";
import { initialState } from './state';

const mutations = {
    [action.GET_TENANT_LIST](state, data) {
        state.tenantList = data;
    },
    [action.GET_TENANT_BY_ID](state, data) {
        state.tenantDetails = data;
    },
    [action.GET_MASTER_SETTING_LIST](state, data) {
        state.masterSettingList = data;
    },
    [action.GET_MASER_SETTING_BY_ID](state, data) {
        state.masterSetting = data;
    },
    [action.GET_DEFAULT_TEMPLATE_LIST](state, data) {
        state.defaultTemplateList = data;
    },
    [action.RESET_STATE](state) {
        Object.assign(state, initialState);
    },
    updateTenentConfigValue(state, data){
        if (!state.tenantList) {
        return undefined;
        }
        const findTanent = state.tenantList.find((t) => t.configname === data.configname);
        if(findTanent){
            // Remove existing config if present
            state.tenantList = state.tenantList.filter(t => t.configname !== data.configname);
            // Add updated config object
            state.tenantList.push({
                ...findTanent,
                configname: data.configname,
                [data.configname]: data.value
            });
        }
         
    }
};

export default mutations;
